// Übergabeprotokolle für Hausmeister freigeben (Ticket #436, Nachfrage Björn 16.10.2026).
//
// Entscheidungen Patrick: Freigabe AM PROTOKOLL (wie ticket_hausmeister bei Tickets), der
// Hausmeister schließt direkt ab, eine Vorlage gibt es nur, wenn das Büro sie hier wählt.
// Was ein Hausmeister damit sehen darf, regeln die Policies der Migration
// 2026-10-16-hausmeister-uebergaben.sql — diese Datei ist nur der Weg dorthin.
import { supabase } from '../supabase/client';

export interface UebergabeFreigabe {
  id: string;
  protokoll_id: string;
  hausmeister_id: string;
  vorlage_id: string | null;
}

export interface VorlagenKandidat {
  id: string;
  art: string;
  durchgefuehrt_am: string | null;
}

/** Freigaben zu mehreren Protokollen auf einmal (für die Liste), gruppiert nach Protokoll. */
export async function ladeFreigabenZu(protokollIds: string[]): Promise<Record<string, UebergabeFreigabe[]>> {
  if (protokollIds.length === 0) return {};
  const { data, error } = await supabase.from('uebergabe_hausmeister')
    .select('id, protokoll_id, hausmeister_id, vorlage_id').in('protokoll_id', protokollIds);
  if (error) { console.error('Hausmeister-Freigaben laden fehlgeschlagen', error.message); return {}; }
  const m: Record<string, UebergabeFreigabe[]> = {};
  for (const f of (data || []) as UebergabeFreigabe[]) (m[f.protokoll_id] ??= []).push(f);
  return m;
}

/**
 * Mögliche Vorlagen: abgeschlossene Protokolle DERSELBEN Einheit, neueste zuerst — typisch
 * das Einzugsprotokoll, wenn jetzt der Auszug ansteht. Ohne Einheit keine Vorschläge: ein
 * Protokoll einer fremden Wohnung als Vorlage wäre eher Fehlerquelle als Hilfe.
 */
export async function ladeVorlagenKandidaten(einheitId: string | null, ohneId: string): Promise<VorlagenKandidat[]> {
  if (!einheitId) return [];
  const { data, error } = await supabase.from('uebergabeprotokolle')
    .select('id, art, durchgefuehrt_am').eq('einheit_id', einheitId).eq('status', 'abgeschlossen')
    .neq('id', ohneId).order('durchgefuehrt_am', { ascending: false }).limit(10);
  if (error) { console.error('Vorlagen laden fehlgeschlagen', error.message); return []; }
  return (data || []) as VorlagenKandidat[];
}

export async function gibFrei(opts: {
  protokollId: string; hausmeisterId: string; vorlageId: string | null; vonId: string | null;
}): Promise<string | null> {
  const { error } = await supabase.from('uebergabe_hausmeister').insert({
    protokoll_id: opts.protokollId,
    hausmeister_id: opts.hausmeisterId,
    vorlage_id: opts.vorlageId,
    freigegeben_von: opts.vonId,
  });
  if (!error) return null;
  return error.code === '23505' ? 'Dieser Hausmeister hat die Übergabe bereits.' : error.message;
}

export async function entzieheFreigabe(id: string): Promise<boolean> {
  const { error } = await supabase.from('uebergabe_hausmeister').delete().eq('id', id);
  return !error;
}

const ART_KURZ: Record<string, string> = { einzug: 'Einzug', auszug: 'Auszug', kauf: 'Übergabe an Eigentümer' };

/** „Auszug · 03.04.2025" für die Auswahl der Vorlage. */
export function vorlagenLabel(v: VorlagenKandidat): string {
  const art = ART_KURZ[v.art] ?? v.art;
  if (!v.durchgefuehrt_am) return art;
  const d = new Date(v.durchgefuehrt_am);
  return `${art} · ${String(d.getDate()).padStart(2, '0')}.${String(d.getMonth() + 1).padStart(2, '0')}.${d.getFullYear()}`;
}
